import {
  CalendarPlusIcon,
  MusicIcon,
  ClockIcon,
  SunIcon,
  MoonIcon,
  RefreshCwIcon,
  type LucideIcon,
} from 'lucide-react';

export interface Automation {
  id: string;
  name: string;
  icon: LucideIcon;
  trigger: string;
  conditions: string[];
  actions: string[];
  status: 'active' | 'paused';
  runs: number;
  timeSaved: string; // e.g. "6.5 hrs"
  successRate: number; // 0-100
}

export const automations: Automation[] = [
  {
    id: 'a1',
    name: 'New Show Booked',
    icon: CalendarPlusIcon,
    trigger: 'When a new show is booked',
    conditions: ['Venue capacity > 200', 'Show is public'],
    actions: [
      'Create social posts',
      'Add to calendar',
      'Generate event graphics',
      'Create production checklist',
      'Schedule internal reminder',
    ],
    status: 'active',
    runs: 12,
    timeSaved: '9.5 hrs',
    successRate: 98,
  },
  {
    id: 'a2',
    name: 'New Song Releases',
    icon: MusicIcon,
    trigger: 'When a new song releases',
    conditions: ['Release is a single or EP'],
    actions: [
      'Add release to the website',
      'Update the featured release spotlight',
      'Create asset checklist',
      'Schedule a launch-day reminder',
    ],
    status: 'active',
    runs: 4,
    timeSaved: '14 hrs',
    successRate: 100,
  },
  {
    id: 'a4',
    name: 'Ticket Link Missing',
    icon: ClockIcon,
    trigger: 'When a published show has no ticket link',
    conditions: ['Show is within 45 days'],
    actions: [
      'Flag the show in Website Studio',
      'Notify Cooper',
      'Schedule another reminder',
    ],
    status: 'active',
    runs: 27,
    timeSaved: '4.5 hrs',
    successRate: 94,
  },
  {
    id: 'a5',
    name: 'Weekly Career Plan',
    icon: SunIcon,
    trigger: 'Every Monday morning',
    conditions: ['At 7:00 AM local time'],
    actions: ['Generate Weekly Career Plan', 'Deliver to Mission Control'],
    status: 'active',
    runs: 34,
    timeSaved: '17 hrs',
    successRate: 100,
  },
  {
    id: 'a6',
    name: 'Weekly Performance Report',
    icon: MoonIcon,
    trigger: 'Every Friday afternoon',
    conditions: ['At 4:00 PM local time'],
    actions: ['Generate Weekly Performance Report', 'Email to Cooper'],
    status: 'active',
    runs: 33,
    timeSaved: '11 hrs',
    successRate: 100,
  },
  {
    id: 'a7',
    name: 'Monthly Career Review',
    icon: RefreshCwIcon,
    trigger: 'Every month',
    conditions: ['On the 1st, at 9:00 AM'],
    actions: ['Generate Career Review', 'Compare to goals', 'Suggest next quarter focus'],
    status: 'paused',
    runs: 8,
    timeSaved: '6 hrs',
    successRate: 100,
  },
];

export const automationInsights = [
  'Shows synced from Bandsintown appear on your site within minutes — no manual re-entry.',
  'Add a 24-hour production reminder to New Show Booked so event assets are ready before announce day.',
  'Dates missing a ticket link are the most common reason a show page underperforms.',
];
